import 'apis/sentry';
import { publishActivation } from 'apis/pubsub';
import { getTokens, pickToken } from 'utils/auth';
import { claimRegistry, hasRegistry } from 'apis/registry';
import { reportError } from 'apis/sentry';
import { allowedHost } from 'utils/settings';
import {
  checkConsent,
  consentCategories,
  getCookie,
  setCookie,
} from 'utils/cookies';
import { getLocalStorage, setLocalStorage } from 'utils/appStorage';

const init = () => {
  if (window.location.hostname !== allowedHost) {
    return;
  }

  const STORAGE_KEY = `igift-agent`;
  let cachedUserId = getCookie(STORAGE_KEY);
  let userId: string = '';
  const DISABLED = 'disabled';
  const LOCAL_STORAGE_KEY = 'claim-registry';
  const hasClaimedRegistry = getLocalStorage(LOCAL_STORAGE_KEY, false);

  const disable = () => {
    // Existing buttons will remain until page reload
    setCookie(STORAGE_KEY, DISABLED, 7);
  };

  const handleHasActiveRegistry = (): Promise<void> => {
    return hasRegistry().then(
      ({
        data: {
          activeRegistry: { __typename },
        },
      }) => {
        if (__typename === 'ActiveRegistryPayload') {
          setCookie(STORAGE_KEY, userId, 7);
          publishActivation();
        } else if (__typename === 'NotFoundError') {
          disable();
        } else if (__typename === 'SuspendedRegistryError') {
          disable();
        } else {
          disable();
          throw new Error(`Unhandled __typename ${__typename}`);
        }
      }
    );
  };

  const handleClaimRegistries = (token: string): Promise<void> => {
    return claimRegistry(token).then(
      ({
        data: {
          claimRegistries: { __typename },
        },
      }) => {
        if (__typename === 'ClaimRegistriesPayload') {
          setLocalStorage(LOCAL_STORAGE_KEY, false);
          return handleHasActiveRegistry();
        } else if (__typename === 'BadInputError') {
          disable();
        } else if (__typename === 'PermissionError') {
          disable();
        } else {
          disable();
          throw new Error(`Unhandled __typename ${__typename}`);
        }
      }
    );
  };

  getTokens()
    .then((tokens) => {
      const user = pickToken(tokens);
      userId = user.id;

      const userHasRegistry =
        cachedUserId !== DISABLED && !user.guest && user.id;

      const userShouldClaimRegistry = userHasRegistry && hasClaimedRegistry;

      if (cachedUserId === userId) {
        publishActivation();
      } else if (userShouldClaimRegistry && tokens.guest?.value) {
        return handleClaimRegistries(tokens.guest.value);
      } else if (userHasRegistry) {
        return handleHasActiveRegistry();
      } else {
        disable();
      }
    })
    .catch((err) => {
      console.error('[igift] Failed to initialize', err);
      reportError(err);
    });

  window.ikea = window.ikea || {};
  window.ikea.giftRegistry = window.ikea.giftRegistry || {};
  window.ikea.giftRegistry.enable = () => {
    setCookie(STORAGE_KEY, userId, 7);
    cachedUserId === DISABLED && publishActivation();
    cachedUserId = userId;
  };
  window.ikea.giftRegistry.disable = disable;
};

window.addEventListener('load', function () {
  if (checkConsent(consentCategories.functionalCookies)) {
    init();
  }
});

document.addEventListener('ikeaCookieConsent', (e) => {
  if (checkConsent(consentCategories.functionalCookies)) {
    init();
  }
});
